export const isNumberValue = (value: unknown): value is number =>
    typeof value === "number";